import {
  AdminMethods as StakingManagerAdminMethods,
  SetTier as stakingManagerSetTier,
  SetTokenTiers as stakingManagerSetTokenTiers,
  RemoveTier as stakingManagerRemoveTier,
  ChangeOwner as stakingManagerChangeOwner,
} from './admin';
import {
  GetterMethods as StakingManagerUserMethods,
  GetTier as stakingManagerGetTier,
  GetAllTiers as stakingManagerGetAllTiers,
  GetLockContract as stakingManagerGetLockContract,
  GetStakedAmount as stakingManagerGetStakedAmount,
} from './getters';

const NamedAdminMethods = {
  stakingManagerSetTier,
  stakingManagerSetTokenTiers,
  stakingManagerRemoveTier,
  stakingManagerChangeOwner,
};
const NamedUserMethods = {
  stakingManagerGetTier,
  stakingManagerGetAllTiers,
  stakingManagerGetLockContract,
  stakingManagerGetStakedAmount,
};

export const StakingManagerMethods = {
  ...NamedAdminMethods,
  ...NamedUserMethods,
}
export {
  StakingManagerAdminMethods,
  StakingManagerUserMethods
};
export default StakingManagerMethods;